import APP from 'types/app';
import API from 'types/api';
import PLAYER from 'types/player';
import _ from 'lodash';

const initialState = {
  id: 0,
  dataReady: false,
  autoplay: undefined,
  pathname: '',
  loginValue: '',
  userRequestedOnStartup: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APP.SET_ID:
      return {
        ...state,
        id: Number(payload),
      };
    case APP.SET_DATA_READY:
      return {
        ...state,
        dataReady: payload,
      };
    case APP.SET_PATHNAME:
      return {
        ...state,
        pathname: payload,
      };
    case PLAYER.HANDLE_CHANGE_PROPERTY: // eslint-disable-line
      return handlePlayerProperty(state, payload);
    case PLAYER.HANDLE_CHANGE_PROPERTIES_PACK:
      return payload.reduce(handlePlayerProperty, state);
    case APP.LOGIN_INPUT_VALUE:
      return {
        ...state,
        loginValue: payload.data,
      };
    case API.GET_USER:
      return {
        ...state,
        userRequestedOnStartup: payload,
      };
    case API.GET_USER_SUCCESS:
      if (!state.userRequestedOnStartup) {
        return {
          ...state,
          dataReady: false,
        };
      }
      return state;
    case API.POST_AUTH_SUCCESS:
    case API.POST_REGISTRATION_SUCCESS:
    case API.POST_LOGOUT_SUCCESS:
      // if registration was not completed, do not modify the state
      if (_.get(payload, ['status', 'completion']) === 'incomplete') {
        return state;
      }
      return {
        ...state,
        dataReady: false,
      };
    default:
      return state;
  }
};

function handlePlayerProperty(state, payload) {
  const propertyName = _.drop(payload.name.split(':')).join(':');
  if (propertyName === 'browserAutoplayState') {
    return {
      ...state,
      autoplay: payload.data,
    };
  }
  return state;
}
